import * as Dialog from '@radix-ui/react-dialog';
import clsx from 'clsx';

export interface ModalProps {
  open: boolean;
  onOpenChange?: (open: boolean) => void;
  title: string;
  description?: string;
  children?: React.ReactNode;
  footer?: React.ReactNode;
  /** 是否显示右上角关闭按钮（助记词备份等强阻断场景传 false）。 */
  dismissible?: boolean;
  /** 是否拦截点击遮罩关闭（强阻断场景传 false）。 */
  closeOnOverlayClick?: boolean;
}

export function Modal({
  open,
  onOpenChange,
  title,
  description,
  children,
  footer,
  dismissible = true,
  closeOnOverlayClick = true,
}: ModalProps): JSX.Element {
  return (
    <Dialog.Root open={open} onOpenChange={onOpenChange}>
      <Dialog.Portal>
        <Dialog.Overlay className="fixed inset-0 z-40 bg-black/60 animate-fade-in" />
        <Dialog.Content
          className={clsx(
            'fixed left-1/2 top-1/2 z-50 w-[min(92vw,520px)] -translate-x-1/2 -translate-y-1/2',
            'card p-5 shadow-xl animate-slide-up',
          )}
          onPointerDownOutside={(e) => {
            if (!closeOnOverlayClick) e.preventDefault();
          }}
          onEscapeKeyDown={(e) => {
            if (!dismissible) e.preventDefault();
          }}
        >
          <Dialog.Title className="text-base font-semibold text-text">{title}</Dialog.Title>
          {description ? <Dialog.Description className="mt-1 text-sm text-dim">{description}</Dialog.Description> : null}
          <div className="mt-4">{children}</div>
          {footer ? <div className="mt-5 flex justify-end gap-2">{footer}</div> : null}
          {dismissible ? (
            <Dialog.Close
              aria-label="关闭"
              className="absolute right-3 top-3 rounded-btn px-2 py-1 text-dim hover:bg-panel-2"
            >
              ✕
            </Dialog.Close>
          ) : null}
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  );
}

export default Modal;
